module.exports = __webpack_public_path__ + "static/media/BIM Collaborate Pro.997ba171.png";